var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-nowrap"},[_c('span',{class:{
    badge: true,
    [`badge-request-status-${_vm.slug}`]: true
}},[_vm._v(_vm._s(_vm.status_text))]),(_vm.withAdditional && _vm.status_additional_text)?_c('span',{staticClass:"small ml-2 text-muted"},[_vm._v(_vm._s(_vm.status_additional_text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }